import {NgModule} from '@angular/core';
import {UserRolePipe} from './user-role.pipe';
import {RoundPipe} from './round.pipe';
import {ThematicGroupPipe} from './thematicGroup.pipe';
import {CategoryTypePipe} from './categoryType.pipe';
import {BindingTypePipe} from './bindingType.pipe';
import {DocumentTypePipe} from './documentType.pipe';
import {StateTypePipe} from './stateType.pipe';
import {ActionTypePipe} from './actionType.pipe';

@NgModule({
    imports: [],
    declarations: [
        UserRolePipe,
        RoundPipe,
        ThematicGroupPipe,
        CategoryTypePipe,
        BindingTypePipe,
        DocumentTypePipe,
        StateTypePipe,
        ActionTypePipe,
    ],
    exports: [
        UserRolePipe,
        RoundPipe,
        ThematicGroupPipe,
        CategoryTypePipe,
        BindingTypePipe,
        DocumentTypePipe,
        StateTypePipe,
        ActionTypePipe,
    ],
    providers: [
        UserRolePipe,
        RoundPipe,
        ThematicGroupPipe,
        CategoryTypePipe,
        BindingTypePipe,
        DocumentTypePipe,
        StateTypePipe,
        ActionTypePipe,
    ]
})

export class CustomPipesModule {
}



// WEBPACK FOOTER //
// ./src/app/+app-custom/pipes/customPipes.module.ts